"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendIntegrationConfiguration = void 0;
var class_validator_1 = require("class-validator");
var with_default_value_1 = require("../../class-transformers/with-default-value");
var class_transformer_1 = require("class-transformer");
var case_insensitive_ingest_1 = require("../../class-transformers/case-insensitive-ingest");
var SendIntegrationConfiguration = (function () {
    function SendIntegrationConfiguration() {
    }
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'is_active' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(false),
        (0, class_validator_1.IsBoolean)({ always: true }),
        __metadata("design:type", Boolean)
    ], SendIntegrationConfiguration.prototype, "isActive", void 0);
    return SendIntegrationConfiguration;
}());
exports.SendIntegrationConfiguration = SendIntegrationConfiguration;
//# sourceMappingURL=send-integration-configuration.js.map